import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'percentFixed'
})
export class PercentFixedPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value === null || value === undefined) return '';

    const percentValue = value * 100;

    if (Number.isInteger(percentValue)) {
      return `${percentValue.toFixed(2)}%`;
      // return `${percentValue}%`;
    } else {
      return `${percentValue.toFixed(2)}%`;
    }
  }
}
